import { Component, OnInit } from '@angular/core';

import { MapComponent } from './map/map.component';

import { UserService } from '../user/user.service';

import { Device } from '../devices/device.model';
import { DeviceService } from '../devices/device.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  public devices: Device[] = [];

  constructor(
    public userService: UserService,
    public deviceService: DeviceService
  ) { }

  ngOnInit(): void {
    this.deviceService.devicesSubject.subscribe( (devices) => {
      this.devices = devices.filter((device) => device.online && device.rssi_value && device.rssi_value <= 1);
      console.log(this.devices);
    })
  }

}
